import { Card, CardContent } from '../ui/card';
import { Star } from 'lucide-react';

const testimonials = [
  { name: "Sarah & James", text: "VerdictIQ helped us see each other's perspective. We stopped arguing and started listening.", rating: 5 },
  { name: "Alex & Morgan", text: "The AI verdict was surprisingly fair. It pointed out things neither of us had considered.", rating: 5 },
  { name: "Priya & Daniel", text: "We use it whenever we can't agree. It's like having a couples counsellor on demand.", rating: 4 },
];

export const TestimonialsSection = () => (
  <section className="py-20 sm:py-28 bg-muted/30" data-testid="testimonials-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-12">
        <span className="text-xs uppercase tracking-[0.2em] font-sans font-semibold text-primary">Testimonials</span>
        <h2 className="mt-3 text-2xl sm:text-3xl lg:text-4xl tracking-tight font-serif font-bold">
          Couples Love VerdictIQ
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {testimonials.map((t) => (
          <Card key={t.name} className="card-hover rounded-2xl border shadow-sm bg-card" data-testid={`testimonial-${t.name}`}>
            <CardContent className="p-6">
              <div className="flex mb-3">
                {[...Array(t.rating)].map((_, j) => <Star key={`filled-${j}`} className="h-4 w-4 fill-yellow-400 text-yellow-400" />)}
                {[...Array(5 - t.rating)].map((_, j) => <Star key={`empty-${j}`} className="h-4 w-4 text-muted-foreground/30" />)}
              </div>
              <p className="text-sm leading-relaxed mb-4 italic">&ldquo;{t.text}&rdquo;</p>
              <p className="text-xs font-semibold text-muted-foreground">{t.name}</p>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  </section>
);
